// Complete list of all valid IANA timezones for newsletter delivery selection
export const COMMON_TIMEZONES = [
  // Africa (52 timezones)
  { value: 'Africa/Abidjan', label: 'Abidjan (UTC+0)', region: 'Africa' },
  { value: 'Africa/Accra', label: 'Accra (UTC+0)', region: 'Africa' },
  { value: 'Africa/Addis_Ababa', label: 'Addis Ababa (UTC+3)', region: 'Africa' },
  { value: 'Africa/Algiers', label: 'Algiers (UTC+1)', region: 'Africa' },
  { value: 'Africa/Asmara', label: 'Asmara (UTC+3)', region: 'Africa' },
  { value: 'Africa/Bamako', label: 'Bamako (UTC+0)', region: 'Africa' },
  { value: 'Africa/Bangui', label: 'Bangui (UTC+1)', region: 'Africa' },
  { value: 'Africa/Banjul', label: 'Banjul (UTC+0)', region: 'Africa' },
  { value: 'Africa/Bissau', label: 'Bissau (UTC+0)', region: 'Africa' },
  { value: 'Africa/Blantyre', label: 'Blantyre (UTC+2)', region: 'Africa' },
  { value: 'Africa/Brazzaville', label: 'Brazzaville (UTC+1)', region: 'Africa' },
  { value: 'Africa/Bujumbura', label: 'Bujumbura (UTC+2)', region: 'Africa' },
  { value: 'Africa/Cairo', label: 'Cairo (UTC+2)', region: 'Africa' },
  { value: 'Africa/Casablanca', label: 'Casablanca (UTC+1)', region: 'Africa' },
  { value: 'Africa/Ceuta', label: 'Ceuta (UTC+1)', region: 'Africa' },
  { value: 'Africa/Conakry', label: 'Conakry (UTC+0)', region: 'Africa' },
  { value: 'Africa/Dakar', label: 'Dakar (UTC+0)', region: 'Africa' },
  { value: 'Africa/Dar_es_Salaam', label: 'Dar es Salaam (UTC+3)', region: 'Africa' },
  { value: 'Africa/Djibouti', label: 'Djibouti (UTC+3)', region: 'Africa' },
  { value: 'Africa/Douala', label: 'Douala (UTC+1)', region: 'Africa' },
  { value: 'Africa/El_Aaiun', label: 'El Aaiun (UTC+1)', region: 'Africa' },
  { value: 'Africa/Freetown', label: 'Freetown (UTC+0)', region: 'Africa' },
  { value: 'Africa/Gaborone', label: 'Gaborone (UTC+2)', region: 'Africa' },
  { value: 'Africa/Harare', label: 'Harare (UTC+2)', region: 'Africa' },
  { value: 'Africa/Johannesburg', label: 'Johannesburg (UTC+2)', region: 'Africa' },
  { value: 'Africa/Juba', label: 'Juba (UTC+2)', region: 'Africa' },
  { value: 'Africa/Kampala', label: 'Kampala (UTC+3)', region: 'Africa' },
  { value: 'Africa/Khartoum', label: 'Khartoum (UTC+2)', region: 'Africa' },
  { value: 'Africa/Kigali', label: 'Kigali (UTC+2)', region: 'Africa' },
  { value: 'Africa/Kinshasa', label: 'Kinshasa (UTC+1)', region: 'Africa' },
  { value: 'Africa/Lagos', label: 'Lagos (UTC+1)', region: 'Africa' },
  { value: 'Africa/Libreville', label: 'Libreville (UTC+1)', region: 'Africa' },
  { value: 'Africa/Lome', label: 'Lome (UTC+0)', region: 'Africa' },
  { value: 'Africa/Luanda', label: 'Luanda (UTC+1)', region: 'Africa' },
  { value: 'Africa/Lubumbashi', label: 'Lubumbashi (UTC+2)', region: 'Africa' },
  { value: 'Africa/Lusaka', label: 'Lusaka (UTC+2)', region: 'Africa' },
  { value: 'Africa/Malabo', label: 'Malabo (UTC+1)', region: 'Africa' },
  { value: 'Africa/Maputo', label: 'Maputo (UTC+2)', region: 'Africa' },
  { value: 'Africa/Maseru', label: 'Maseru (UTC+2)', region: 'Africa' },
  { value: 'Africa/Mbabane', label: 'Mbabane (UTC+2)', region: 'Africa' },
  { value: 'Africa/Mogadishu', label: 'Mogadishu (UTC+3)', region: 'Africa' },
  { value: 'Africa/Monrovia', label: 'Monrovia (UTC+0)', region: 'Africa' },
  { value: 'Africa/Nairobi', label: 'Nairobi (UTC+3)', region: 'Africa' },
  { value: 'Africa/Ndjamena', label: 'Ndjamena (UTC+1)', region: 'Africa' },
  { value: 'Africa/Niamey', label: 'Niamey (UTC+1)', region: 'Africa' },
  { value: 'Africa/Nouakchott', label: 'Nouakchott (UTC+0)', region: 'Africa' },
  { value: 'Africa/Ouagadougou', label: 'Ouagadougou (UTC+0)', region: 'Africa' },
  { value: 'Africa/Porto-Novo', label: 'Porto-Novo (UTC+1)', region: 'Africa' },
  { value: 'Africa/Sao_Tome', label: 'Sao Tome (UTC+0)', region: 'Africa' },
  { value: 'Africa/Tripoli', label: 'Tripoli (UTC+2)', region: 'Africa' },
  { value: 'Africa/Tunis', label: 'Tunis (UTC+1)', region: 'Africa' },
  { value: 'Africa/Windhoek', label: 'Windhoek (UTC+2)', region: 'Africa' },

  // Americas (152 timezones)
  { value: 'America/Adak', label: 'Adak (UTC-10)', region: 'Americas' },
  { value: 'America/Anchorage', label: 'Anchorage (UTC-9)', region: 'Americas' },
  { value: 'America/Anguilla', label: 'Anguilla (UTC-4)', region: 'Americas' },
  { value: 'America/Antigua', label: 'Antigua (UTC-4)', region: 'Americas' },
  { value: 'America/Araguaina', label: 'Araguaina (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/Catamarca', label: 'Catamarca (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/Cordoba', label: 'Cordoba (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/Jujuy', label: 'Jujuy (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/La_Rioja', label: 'La Rioja (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/Mendoza', label: 'Mendoza (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/Rio_Gallegos', label: 'Rio Gallegos (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/Salta', label: 'Salta (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/San_Juan', label: 'San Juan (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/San_Luis', label: 'San Luis (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/Tucuman', label: 'Tucuman (UTC-3)', region: 'Americas' },
  { value: 'America/Argentina/Ushuaia', label: 'Ushuaia (UTC-3)', region: 'Americas' },
  { value: 'America/Aruba', label: 'Aruba (UTC-4)', region: 'Americas' },
  { value: 'America/Asuncion', label: 'Asuncion (UTC-4)', region: 'Americas' },
  { value: 'America/Atikokan', label: 'Atikokan (UTC-5)', region: 'Americas' },
  { value: 'America/Bahia', label: 'Bahia (UTC-3)', region: 'Americas' },
  { value: 'America/Bahia_Banderas', label: 'Bahia Banderas (UTC-6)', region: 'Americas' },
  { value: 'America/Barbados', label: 'Barbados (UTC-4)', region: 'Americas' },
  { value: 'America/Belem', label: 'Belem (UTC-3)', region: 'Americas' },
  { value: 'America/Belize', label: 'Belize (UTC-6)', region: 'Americas' },
  { value: 'America/Blanc-Sablon', label: 'Blanc-Sablon (UTC-4)', region: 'Americas' },
  { value: 'America/Boa_Vista', label: 'Boa Vista (UTC-4)', region: 'Americas' },
  { value: 'America/Bogota', label: 'Bogota (UTC-5)', region: 'Americas' },
  { value: 'America/Boise', label: 'Boise (UTC-7)', region: 'Americas' },
  { value: 'America/Cambridge_Bay', label: 'Cambridge Bay (UTC-7)', region: 'Americas' },
  { value: 'America/Campo_Grande', label: 'Campo Grande (UTC-4)', region: 'Americas' },
  { value: 'America/Cancun', label: 'Cancun (UTC-5)', region: 'Americas' },
  { value: 'America/Caracas', label: 'Caracas (UTC-4)', region: 'Americas' },
  { value: 'America/Cayenne', label: 'Cayenne (UTC-3)', region: 'Americas' },
  { value: 'America/Cayman', label: 'Cayman (UTC-5)', region: 'Americas' },
  { value: 'America/Chicago', label: 'Chicago (UTC-6)', region: 'Americas' },
  { value: 'America/Chihuahua', label: 'Chihuahua (UTC-6)', region: 'Americas' },
  { value: 'America/Ciudad_Juarez', label: 'Ciudad Juarez (UTC-7)', region: 'Americas' },
  { value: 'America/Costa_Rica', label: 'Costa Rica (UTC-6)', region: 'Americas' },
  { value: 'America/Creston', label: 'Creston (UTC-7)', region: 'Americas' },
  { value: 'America/Cuiaba', label: 'Cuiaba (UTC-4)', region: 'Americas' },
  { value: 'America/Curacao', label: 'Curacao (UTC-4)', region: 'Americas' },
  { value: 'America/Danmarkshavn', label: 'Danmarkshavn (UTC+0)', region: 'Americas' },
  { value: 'America/Dawson', label: 'Dawson (UTC-7)', region: 'Americas' },
  { value: 'America/Dawson_Creek', label: 'Dawson Creek (UTC-7)', region: 'Americas' },
  { value: 'America/Denver', label: 'Denver (UTC-7)', region: 'Americas' },
  { value: 'America/Detroit', label: 'Detroit (UTC-5)', region: 'Americas' },
  { value: 'America/Dominica', label: 'Dominica (UTC-4)', region: 'Americas' },
  { value: 'America/Edmonton', label: 'Edmonton (UTC-7)', region: 'Americas' },
  { value: 'America/Eirunepe', label: 'Eirunepe (UTC-5)', region: 'Americas' },
  { value: 'America/El_Salvador', label: 'El Salvador (UTC-6)', region: 'Americas' },
  { value: 'America/Fort_Nelson', label: 'Fort Nelson (UTC-7)', region: 'Americas' },
  { value: 'America/Fortaleza', label: 'Fortaleza (UTC-3)', region: 'Americas' },
  { value: 'America/Glace_Bay', label: 'Glace Bay (UTC-4)', region: 'Americas' },
  { value: 'America/Goose_Bay', label: 'Goose Bay (UTC-4)', region: 'Americas' },
  { value: 'America/Grand_Turk', label: 'Grand Turk (UTC-5)', region: 'Americas' },
  { value: 'America/Grenada', label: 'Grenada (UTC-4)', region: 'Americas' },
  { value: 'America/Guadeloupe', label: 'Guadeloupe (UTC-4)', region: 'Americas' },
  { value: 'America/Guatemala', label: 'Guatemala (UTC-6)', region: 'Americas' },
  { value: 'America/Guayaquil', label: 'Guayaquil (UTC-5)', region: 'Americas' },
  { value: 'America/Guyana', label: 'Guyana (UTC-4)', region: 'Americas' },
  { value: 'America/Halifax', label: 'Halifax (UTC-4)', region: 'Americas' },
  { value: 'America/Havana', label: 'Havana (UTC-5)', region: 'Americas' },
  { value: 'America/Hermosillo', label: 'Hermosillo (UTC-7)', region: 'Americas' },
  { value: 'America/Indiana/Indianapolis', label: 'Indianapolis (UTC-5)', region: 'Americas' },
  { value: 'America/Indiana/Knox', label: 'Knox, Indiana (UTC-6)', region: 'Americas' },
  { value: 'America/Indiana/Marengo', label: 'Marengo, Indiana (UTC-5)', region: 'Americas' },
  { value: 'America/Indiana/Petersburg', label: 'Petersburg, Indiana (UTC-5)', region: 'Americas' },
  { value: 'America/Indiana/Tell_City', label: 'Tell City, Indiana (UTC-6)', region: 'Americas' },
  { value: 'America/Indiana/Vevay', label: 'Vevay, Indiana (UTC-5)', region: 'Americas' },
  { value: 'America/Indiana/Vincennes', label: 'Vincennes, Indiana (UTC-5)', region: 'Americas' },
  { value: 'America/Indiana/Winamac', label: 'Winamac, Indiana (UTC-5)', region: 'Americas' },
  { value: 'America/Inuvik', label: 'Inuvik (UTC-7)', region: 'Americas' },
  { value: 'America/Iqaluit', label: 'Iqaluit (UTC-5)', region: 'Americas' },
  { value: 'America/Jamaica', label: 'Jamaica (UTC-5)', region: 'Americas' },
  { value: 'America/Juneau', label: 'Juneau (UTC-9)', region: 'Americas' },
  { value: 'America/Kentucky/Louisville', label: 'Louisville (UTC-5)', region: 'Americas' },
  { value: 'America/Kentucky/Monticello', label: 'Monticello, Kentucky (UTC-5)', region: 'Americas' },
  { value: 'America/Kralendijk', label: 'Kralendijk (UTC-4)', region: 'Americas' },
  { value: 'America/La_Paz', label: 'La Paz (UTC-4)', region: 'Americas' },
  { value: 'America/Lima', label: 'Lima (UTC-5)', region: 'Americas' },
  { value: 'America/Los_Angeles', label: 'Los Angeles (UTC-8)', region: 'Americas' },
  { value: 'America/Lower_Princes', label: 'Lower Princes (UTC-4)', region: 'Americas' },
  { value: 'America/Maceio', label: 'Maceio (UTC-3)', region: 'Americas' },
  { value: 'America/Managua', label: 'Managua (UTC-6)', region: 'Americas' },
  { value: 'America/Manaus', label: 'Manaus (UTC-4)', region: 'Americas' },
  { value: 'America/Marigot', label: 'Marigot (UTC-4)', region: 'Americas' },
  { value: 'America/Martinique', label: 'Martinique (UTC-4)', region: 'Americas' },
  { value: 'America/Matamoros', label: 'Matamoros (UTC-6)', region: 'Americas' },
  { value: 'America/Mazatlan', label: 'Mazatlan (UTC-7)', region: 'Americas' },
  { value: 'America/Menominee', label: 'Menominee (UTC-6)', region: 'Americas' },
  { value: 'America/Merida', label: 'Merida (UTC-6)', region: 'Americas' },
  { value: 'America/Metlakatla', label: 'Metlakatla (UTC-9)', region: 'Americas' },
  { value: 'America/Mexico_City', label: 'Mexico City (UTC-6)', region: 'Americas' },
  { value: 'America/Miquelon', label: 'Miquelon (UTC-3)', region: 'Americas' },
  { value: 'America/Moncton', label: 'Moncton (UTC-4)', region: 'Americas' },
  { value: 'America/Monterrey', label: 'Monterrey (UTC-6)', region: 'Americas' },
  { value: 'America/Montevideo', label: 'Montevideo (UTC-3)', region: 'Americas' },
  { value: 'America/Montserrat', label: 'Montserrat (UTC-4)', region: 'Americas' },
  { value: 'America/Nassau', label: 'Nassau (UTC-5)', region: 'Americas' },
  { value: 'America/New_York', label: 'New York (UTC-5)', region: 'Americas' },
  { value: 'America/Nome', label: 'Nome (UTC-9)', region: 'Americas' },
  { value: 'America/Noronha', label: 'Noronha (UTC-2)', region: 'Americas' },
  { value: 'America/North_Dakota/Beulah', label: 'Beulah, North Dakota (UTC-6)', region: 'Americas' },
  { value: 'America/North_Dakota/Center', label: 'Center, North Dakota (UTC-6)', region: 'Americas' },
  { value: 'America/North_Dakota/New_Salem', label: 'New Salem, North Dakota (UTC-6)', region: 'Americas' },
  { value: 'America/Nuuk', label: 'Nuuk (UTC-2)', region: 'Americas' },
  { value: 'America/Ojinaga', label: 'Ojinaga (UTC-6)', region: 'Americas' },
  { value: 'America/Panama', label: 'Panama (UTC-5)', region: 'Americas' },
  { value: 'America/Paramaribo', label: 'Paramaribo (UTC-3)', region: 'Americas' },
  { value: 'America/Phoenix', label: 'Phoenix (UTC-7)', region: 'Americas' },
  { value: 'America/Port-au-Prince', label: 'Port-au-Prince (UTC-5)', region: 'Americas' },
  { value: 'America/Port_of_Spain', label: 'Port of Spain (UTC-4)', region: 'Americas' },
  { value: 'America/Porto_Velho', label: 'Porto Velho (UTC-4)', region: 'Americas' },
  { value: 'America/Puerto_Rico', label: 'Puerto Rico (UTC-4)', region: 'Americas' },
  { value: 'America/Punta_Arenas', label: 'Punta Arenas (UTC-3)', region: 'Americas' },
  { value: 'America/Rankin_Inlet', label: 'Rankin Inlet (UTC-6)', region: 'Americas' },
  { value: 'America/Recife', label: 'Recife (UTC-3)', region: 'Americas' },
  { value: 'America/Regina', label: 'Regina (UTC-6)', region: 'Americas' },
  { value: 'America/Resolute', label: 'Resolute (UTC-6)', region: 'Americas' },
  { value: 'America/Rio_Branco', label: 'Rio Branco (UTC-5)', region: 'Americas' },
  { value: 'America/Santarem', label: 'Santarem (UTC-3)', region: 'Americas' },
  { value: 'America/Santiago', label: 'Santiago (UTC-4)', region: 'Americas' },
  { value: 'America/Santo_Domingo', label: 'Santo Domingo (UTC-4)', region: 'Americas' },
  { value: 'America/Sao_Paulo', label: 'São Paulo (UTC-3)', region: 'Americas' },
  { value: 'America/Scoresbysund', label: 'Scoresbysund (UTC-2)', region: 'Americas' },
  { value: 'America/Sitka', label: 'Sitka (UTC-9)', region: 'Americas' },
  { value: 'America/St_Barthelemy', label: 'St Barthelemy (UTC-4)', region: 'Americas' },
  { value: 'America/St_Johns', label: 'St Johns (UTC-3:30)', region: 'Americas' },
  { value: 'America/St_Kitts', label: 'St Kitts (UTC-4)', region: 'Americas' },
  { value: 'America/St_Lucia', label: 'St Lucia (UTC-4)', region: 'Americas' },
  { value: 'America/St_Thomas', label: 'St Thomas (UTC-4)', region: 'Americas' },
  { value: 'America/St_Vincent', label: 'St Vincent (UTC-4)', region: 'Americas' },
  { value: 'America/Swift_Current', label: 'Swift Current (UTC-6)', region: 'Americas' },
  { value: 'America/Tegucigalpa', label: 'Tegucigalpa (UTC-6)', region: 'Americas' },
  { value: 'America/Thule', label: 'Thule (UTC-4)', region: 'Americas' },
  { value: 'America/Tijuana', label: 'Tijuana (UTC-8)', region: 'Americas' },
  { value: 'America/Toronto', label: 'Toronto (UTC-5)', region: 'Americas' },
  { value: 'America/Tortola', label: 'Tortola (UTC-4)', region: 'Americas' },
  { value: 'America/Vancouver', label: 'Vancouver (UTC-8)', region: 'Americas' },
  { value: 'America/Whitehorse', label: 'Whitehorse (UTC-7)', region: 'Americas' },
  { value: 'America/Winnipeg', label: 'Winnipeg (UTC-6)', region: 'Americas' },
  { value: 'America/Yakutat', label: 'Yakutat (UTC-9)', region: 'Americas' },

  // Antarctica (12 timezones)
  { value: 'Antarctica/Casey', label: 'Casey (UTC+11)', region: 'Antarctica' },
  { value: 'Antarctica/Davis', label: 'Davis (UTC+7)', region: 'Antarctica' },
  { value: 'Antarctica/DumontDUrville', label: 'DumontDUrville (UTC+10)', region: 'Antarctica' },
  { value: 'Antarctica/Macquarie', label: 'Macquarie (UTC+11)', region: 'Antarctica' },
  { value: 'Antarctica/Mawson', label: 'Mawson (UTC+5)', region: 'Antarctica' },
  { value: 'Antarctica/McMurdo', label: 'McMurdo (UTC+13)', region: 'Antarctica' },
  { value: 'Antarctica/Palmer', label: 'Palmer (UTC-3)', region: 'Antarctica' },
  { value: 'Antarctica/Rothera', label: 'Rothera (UTC-3)', region: 'Antarctica' },
  { value: 'Antarctica/Syowa', label: 'Syowa (UTC+3)', region: 'Antarctica' },
  { value: 'Antarctica/Troll', label: 'Troll (UTC+2)', region: 'Antarctica' },
  { value: 'Antarctica/Vostok', label: 'Vostok (UTC+5)', region: 'Antarctica' },

  // Arctic (1 timezone)
  { value: 'Arctic/Longyearbyen', label: 'Longyearbyen (UTC+1)', region: 'Arctic' },

  // Asia (87 timezones)
  { value: 'Asia/Aden', label: 'Aden (UTC+3)', region: 'Asia' },
  { value: 'Asia/Almaty', label: 'Almaty (UTC+5)', region: 'Asia' },
  { value: 'Asia/Amman', label: 'Amman (UTC+3)', region: 'Asia' },
  { value: 'Asia/Anadyr', label: 'Anadyr (UTC+12)', region: 'Asia' },
  { value: 'Asia/Aqtau', label: 'Aqtau (UTC+5)', region: 'Asia' },
  { value: 'Asia/Aqtobe', label: 'Aqtobe (UTC+5)', region: 'Asia' },
  { value: 'Asia/Ashgabat', label: 'Ashgabat (UTC+5)', region: 'Asia' },
  { value: 'Asia/Atyrau', label: 'Atyrau (UTC+5)', region: 'Asia' },
  { value: 'Asia/Baghdad', label: 'Baghdad (UTC+3)', region: 'Asia' },
  { value: 'Asia/Bahrain', label: 'Bahrain (UTC+3)', region: 'Asia' },
  { value: 'Asia/Baku', label: 'Baku (UTC+4)', region: 'Asia' },
  { value: 'Asia/Bangkok', label: 'Bangkok (UTC+7)', region: 'Asia' },
  { value: 'Asia/Barnaul', label: 'Barnaul (UTC+7)', region: 'Asia' },
  { value: 'Asia/Beirut', label: 'Beirut (UTC+2)', region: 'Asia' },
  { value: 'Asia/Bishkek', label: 'Bishkek (UTC+6)', region: 'Asia' },
  { value: 'Asia/Brunei', label: 'Brunei (UTC+8)', region: 'Asia' },
  { value: 'Asia/Chita', label: 'Chita (UTC+9)', region: 'Asia' },
  { value: 'Asia/Choibalsan', label: 'Choibalsan (UTC+8)', region: 'Asia' },
  { value: 'Asia/Colombo', label: 'Colombo (UTC+5:30)', region: 'Asia' },
  { value: 'Asia/Damascus', label: 'Damascus (UTC+3)', region: 'Asia' },
  { value: 'Asia/Dhaka', label: 'Dhaka (UTC+6)', region: 'Asia' },
  { value: 'Asia/Dili', label: 'Dili (UTC+9)', region: 'Asia' },
  { value: 'Asia/Dubai', label: 'Dubai (UTC+4)', region: 'Asia' },
  { value: 'Asia/Dushanbe', label: 'Dushanbe (UTC+5)', region: 'Asia' },
  { value: 'Asia/Famagusta', label: 'Famagusta (UTC+2)', region: 'Asia' },
  { value: 'Asia/Gaza', label: 'Gaza (UTC+2)', region: 'Asia' },
  { value: 'Asia/Hebron', label: 'Hebron (UTC+2)', region: 'Asia' },
  { value: 'Asia/Ho_Chi_Minh', label: 'Ho Chi Minh (UTC+7)', region: 'Asia' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong (UTC+8)', region: 'Asia' },
  { value: 'Asia/Hovd', label: 'Hovd (UTC+7)', region: 'Asia' },
  { value: 'Asia/Irkutsk', label: 'Irkutsk (UTC+8)', region: 'Asia' },
  { value: 'Asia/Jakarta', label: 'Jakarta (UTC+7)', region: 'Asia' },
  { value: 'Asia/Jayapura', label: 'Jayapura (UTC+9)', region: 'Asia' },
  { value: 'Asia/Jerusalem', label: 'Jerusalem (UTC+2)', region: 'Asia' },
  { value: 'Asia/Kabul', label: 'Kabul (UTC+4:30)', region: 'Asia' },
  { value: 'Asia/Kamchatka', label: 'Kamchatka (UTC+12)', region: 'Asia' },
  { value: 'Asia/Karachi', label: 'Karachi (UTC+5)', region: 'Asia' },
  { value: 'Asia/Kathmandu', label: 'Kathmandu (UTC+5:45)', region: 'Asia' },
  { value: 'Asia/Khandyga', label: 'Khandyga (UTC+9)', region: 'Asia' },
  { value: 'Asia/Kolkata', label: 'Kolkata (UTC+5:30)', region: 'Asia' },
  { value: 'Asia/Krasnoyarsk', label: 'Krasnoyarsk (UTC+7)', region: 'Asia' },
  { value: 'Asia/Kuala_Lumpur', label: 'Kuala Lumpur (UTC+8)', region: 'Asia' },
  { value: 'Asia/Kuching', label: 'Kuching (UTC+8)', region: 'Asia' },
  { value: 'Asia/Kuwait', label: 'Kuwait (UTC+3)', region: 'Asia' },
  { value: 'Asia/Macau', label: 'Macau (UTC+8)', region: 'Asia' },
  { value: 'Asia/Magadan', label: 'Magadan (UTC+11)', region: 'Asia' },
  { value: 'Asia/Makassar', label: 'Makassar (UTC+8)', region: 'Asia' },
  { value: 'Asia/Manila', label: 'Manila (UTC+8)', region: 'Asia' },
  { value: 'Asia/Muscat', label: 'Muscat (UTC+4)', region: 'Asia' },
  { value: 'Asia/Nicosia', label: 'Nicosia (UTC+2)', region: 'Asia' },
  { value: 'Asia/Novokuznetsk', label: 'Novokuznetsk (UTC+7)', region: 'Asia' },
  { value: 'Asia/Novosibirsk', label: 'Novosibirsk (UTC+7)', region: 'Asia' },
  { value: 'Asia/Omsk', label: 'Omsk (UTC+6)', region: 'Asia' },
  { value: 'Asia/Oral', label: 'Oral (UTC+5)', region: 'Asia' },
  { value: 'Asia/Phnom_Penh', label: 'Phnom Penh (UTC+7)', region: 'Asia' },
  { value: 'Asia/Pontianak', label: 'Pontianak (UTC+7)', region: 'Asia' },
  { value: 'Asia/Pyongyang', label: 'Pyongyang (UTC+9)', region: 'Asia' },
  { value: 'Asia/Qatar', label: 'Qatar (UTC+3)', region: 'Asia' },
  { value: 'Asia/Qostanay', label: 'Qostanay (UTC+5)', region: 'Asia' },
  { value: 'Asia/Qyzylorda', label: 'Qyzylorda (UTC+5)', region: 'Asia' },
  { value: 'Asia/Riyadh', label: 'Riyadh (UTC+3)', region: 'Asia' },
  { value: 'Asia/Sakhalin', label: 'Sakhalin (UTC+11)', region: 'Asia' },
  { value: 'Asia/Samarkand', label: 'Samarkand (UTC+5)', region: 'Asia' },
  { value: 'Asia/Seoul', label: 'Seoul (UTC+9)', region: 'Asia' },
  { value: 'Asia/Shanghai', label: 'Shanghai (UTC+8)', region: 'Asia' },
  { value: 'Asia/Singapore', label: 'Singapore (UTC+8)', region: 'Asia' },
  { value: 'Asia/Srednekolymsk', label: 'Srednekolymsk (UTC+11)', region: 'Asia' },
  { value: 'Asia/Taipei', label: 'Taipei (UTC+8)', region: 'Asia' },
  { value: 'Asia/Tashkent', label: 'Tashkent (UTC+5)', region: 'Asia' },
  { value: 'Asia/Tbilisi', label: 'Tbilisi (UTC+4)', region: 'Asia' },
  { value: 'Asia/Tehran', label: 'Tehran (UTC+3:30)', region: 'Asia' },
  { value: 'Asia/Thimphu', label: 'Thimphu (UTC+6)', region: 'Asia' },
  { value: 'Asia/Tokyo', label: 'Tokyo (UTC+9)', region: 'Asia' },
  { value: 'Asia/Tomsk', label: 'Tomsk (UTC+7)', region: 'Asia' },
  { value: 'Asia/Ulaanbaatar', label: 'Ulaanbaatar (UTC+8)', region: 'Asia' },
  { value: 'Asia/Urumqi', label: 'Urumqi (UTC+6)', region: 'Asia' },
  { value: 'Asia/Ust-Nera', label: 'Ust-Nera (UTC+10)', region: 'Asia' },
  { value: 'Asia/Vientiane', label: 'Vientiane (UTC+7)', region: 'Asia' },
  { value: 'Asia/Vladivostok', label: 'Vladivostok (UTC+10)', region: 'Asia' },
  { value: 'Asia/Yakutsk', label: 'Yakutsk (UTC+9)', region: 'Asia' },
  { value: 'Asia/Yangon', label: 'Yangon (UTC+6:30)', region: 'Asia' },
  { value: 'Asia/Yekaterinburg', label: 'Yekaterinburg (UTC+5)', region: 'Asia' },
  { value: 'Asia/Yerevan', label: 'Yerevan (UTC+4)', region: 'Asia' },

  // Atlantic (10 timezones)
  { value: 'Atlantic/Azores', label: 'Azores (UTC-1)', region: 'Atlantic' },
  { value: 'Atlantic/Bermuda', label: 'Bermuda (UTC-4)', region: 'Atlantic' },
  { value: 'Atlantic/Canary', label: 'Canary (UTC+0)', region: 'Atlantic' },
  { value: 'Atlantic/Cape_Verde', label: 'Cape Verde (UTC-1)', region: 'Atlantic' },
  { value: 'Atlantic/Faroe', label: 'Faroe (UTC+0)', region: 'Atlantic' },
  { value: 'Atlantic/Madeira', label: 'Madeira (UTC+0)', region: 'Atlantic' },
  { value: 'Atlantic/Reykjavik', label: 'Reykjavik (UTC+0)', region: 'Atlantic' },
  { value: 'Atlantic/South_Georgia', label: 'South Georgia (UTC-2)', region: 'Atlantic' },
  { value: 'Atlantic/St_Helena', label: 'St Helena (UTC+0)', region: 'Atlantic' },
  { value: 'Atlantic/Stanley', label: 'Stanley (UTC-3)', region: 'Atlantic' },

  // Australia (12 timezones)
  { value: 'Australia/Adelaide', label: 'Adelaide (UTC+9:30)', region: 'Australia' },
  { value: 'Australia/Brisbane', label: 'Brisbane (UTC+10)', region: 'Australia' },
  { value: 'Australia/Broken_Hill', label: 'Broken Hill (UTC+9:30)', region: 'Australia' },
  { value: 'Australia/Darwin', label: 'Darwin (UTC+9:30)', region: 'Australia' },
  { value: 'Australia/Eucla', label: 'Eucla (UTC+8:45)', region: 'Australia' },
  { value: 'Australia/Hobart', label: 'Hobart (UTC+10)', region: 'Australia' },
  { value: 'Australia/Lindeman', label: 'Lindeman (UTC+10)', region: 'Australia' },
  { value: 'Australia/Lord_Howe', label: 'Lord Howe (UTC+10:30)', region: 'Australia' },
  { value: 'Australia/Melbourne', label: 'Melbourne (UTC+10)', region: 'Australia' },
  { value: 'Australia/Perth', label: 'Perth (UTC+8)', region: 'Australia' },
  { value: 'Australia/Sydney', label: 'Sydney (UTC+10)', region: 'Australia' },

  // Europe (60 timezones)
  { value: 'Europe/Amsterdam', label: 'Amsterdam (UTC+1)', region: 'Europe' },
  { value: 'Europe/Andorra', label: 'Andorra (UTC+1)', region: 'Europe' },
  { value: 'Europe/Astrakhan', label: 'Astrakhan (UTC+4)', region: 'Europe' },
  { value: 'Europe/Athens', label: 'Athens (UTC+2)', region: 'Europe' },
  { value: 'Europe/Belgrade', label: 'Belgrade (UTC+1)', region: 'Europe' },
  { value: 'Europe/Berlin', label: 'Berlin (UTC+1)', region: 'Europe' },
  { value: 'Europe/Bratislava', label: 'Bratislava (UTC+1)', region: 'Europe' },
  { value: 'Europe/Brussels', label: 'Brussels (UTC+1)', region: 'Europe' },
  { value: 'Europe/Bucharest', label: 'Bucharest (UTC+2)', region: 'Europe' },
  { value: 'Europe/Budapest', label: 'Budapest (UTC+1)', region: 'Europe' },
  { value: 'Europe/Busingen', label: 'Busingen (UTC+1)', region: 'Europe' },
  { value: 'Europe/Chisinau', label: 'Chisinau (UTC+2)', region: 'Europe' },
  { value: 'Europe/Copenhagen', label: 'Copenhagen (UTC+1)', region: 'Europe' },
  { value: 'Europe/Dublin', label: 'Dublin (UTC+0)', region: 'Europe' },
  { value: 'Europe/Gibraltar', label: 'Gibraltar (UTC+1)', region: 'Europe' },
  { value: 'Europe/Guernsey', label: 'Guernsey (UTC+0)', region: 'Europe' },
  { value: 'Europe/Helsinki', label: 'Helsinki (UTC+2)', region: 'Europe' },
  { value: 'Europe/Isle_of_Man', label: 'Isle of Man (UTC+0)', region: 'Europe' },
  { value: 'Europe/Istanbul', label: 'Istanbul (UTC+3)', region: 'Europe' },
  { value: 'Europe/Jersey', label: 'Jersey (UTC+0)', region: 'Europe' },
  { value: 'Europe/Kaliningrad', label: 'Kaliningrad (UTC+2)', region: 'Europe' },
  { value: 'Europe/Kirov', label: 'Kirov (UTC+3)', region: 'Europe' },
  { value: 'Europe/Kyiv', label: 'Kyiv (UTC+2)', region: 'Europe' },
  { value: 'Europe/Lisbon', label: 'Lisbon (UTC+0)', region: 'Europe' },
  { value: 'Europe/Ljubljana', label: 'Ljubljana (UTC+1)', region: 'Europe' },
  { value: 'Europe/London', label: 'London (UTC+0)', region: 'Europe' },
  { value: 'Europe/Luxembourg', label: 'Luxembourg (UTC+1)', region: 'Europe' },
  { value: 'Europe/Madrid', label: 'Madrid (UTC+1)', region: 'Europe' },
  { value: 'Europe/Malta', label: 'Malta (UTC+1)', region: 'Europe' },
  { value: 'Europe/Mariehamn', label: 'Mariehamn (UTC+2)', region: 'Europe' },
  { value: 'Europe/Minsk', label: 'Minsk (UTC+3)', region: 'Europe' },
  { value: 'Europe/Monaco', label: 'Monaco (UTC+1)', region: 'Europe' },
  { value: 'Europe/Moscow', label: 'Moscow (UTC+3)', region: 'Europe' },
  { value: 'Europe/Oslo', label: 'Oslo (UTC+1)', region: 'Europe' },
  { value: 'Europe/Paris', label: 'Paris (UTC+1)', region: 'Europe' },
  { value: 'Europe/Podgorica', label: 'Podgorica (UTC+1)', region: 'Europe' },
  { value: 'Europe/Prague', label: 'Prague (UTC+1)', region: 'Europe' },
  { value: 'Europe/Riga', label: 'Riga (UTC+2)', region: 'Europe' },
  { value: 'Europe/Rome', label: 'Rome (UTC+1)', region: 'Europe' },
  { value: 'Europe/Samara', label: 'Samara (UTC+4)', region: 'Europe' },
  { value: 'Europe/San_Marino', label: 'San Marino (UTC+1)', region: 'Europe' },
  { value: 'Europe/Sarajevo', label: 'Sarajevo (UTC+1)', region: 'Europe' },
  { value: 'Europe/Saratov', label: 'Saratov (UTC+4)', region: 'Europe' },
  { value: 'Europe/Simferopol', label: 'Simferopol (UTC+3)', region: 'Europe' },
  { value: 'Europe/Skopje', label: 'Skopje (UTC+1)', region: 'Europe' },
  { value: 'Europe/Sofia', label: 'Sofia (UTC+2)', region: 'Europe' },
  { value: 'Europe/Stockholm', label: 'Stockholm (UTC+1)', region: 'Europe' },
  { value: 'Europe/Tallinn', label: 'Tallinn (UTC+2)', region: 'Europe' },
  { value: 'Europe/Tirane', label: 'Tirane (UTC+1)', region: 'Europe' },
  { value: 'Europe/Ulyanovsk', label: 'Ulyanovsk (UTC+4)', region: 'Europe' },
  { value: 'Europe/Vaduz', label: 'Vaduz (UTC+1)', region: 'Europe' },
  { value: 'Europe/Vatican', label: 'Vatican (UTC+1)', region: 'Europe' },
  { value: 'Europe/Vienna', label: 'Vienna (UTC+1)', region: 'Europe' },
  { value: 'Europe/Vilnius', label: 'Vilnius (UTC+2)', region: 'Europe' },
  { value: 'Europe/Volgograd', label: 'Volgograd (UTC+3)', region: 'Europe' },
  { value: 'Europe/Warsaw', label: 'Warsaw (UTC+1)', region: 'Europe' },
  { value: 'Europe/Zagreb', label: 'Zagreb (UTC+1)', region: 'Europe' },
  { value: 'Europe/Zurich', label: 'Zurich (UTC+1)', region: 'Europe' },

  // Indian (11 timezones)
  { value: 'Indian/Antananarivo', label: 'Antananarivo (UTC+3)', region: 'Indian' },
  { value: 'Indian/Chagos', label: 'Chagos (UTC+6)', region: 'Indian' },
  { value: 'Indian/Christmas', label: 'Christmas (UTC+7)', region: 'Indian' },
  { value: 'Indian/Cocos', label: 'Cocos (UTC+6:30)', region: 'Indian' },
  { value: 'Indian/Comoro', label: 'Comoro (UTC+3)', region: 'Indian' },
  { value: 'Indian/Kerguelen', label: 'Kerguelen (UTC+5)', region: 'Indian' },
  { value: 'Indian/Mahe', label: 'Mahe (UTC+4)', region: 'Indian' },
  { value: 'Indian/Maldives', label: 'Maldives (UTC+5)', region: 'Indian' },
  { value: 'Indian/Mauritius', label: 'Mauritius (UTC+4)', region: 'Indian' },
  { value: 'Indian/Mayotte', label: 'Mayotte (UTC+3)', region: 'Indian' },
  { value: 'Indian/Reunion', label: 'Reunion (UTC+4)', region: 'Indian' },

  // Pacific (40 timezones)
  { value: 'Pacific/Apia', label: 'Apia (UTC+13)', region: 'Pacific' },
  { value: 'Pacific/Auckland', label: 'Auckland (UTC+12)', region: 'Pacific' },
  { value: 'Pacific/Bougainville', label: 'Bougainville (UTC+11)', region: 'Pacific' },
  { value: 'Pacific/Chatham', label: 'Chatham (UTC+12:45)', region: 'Pacific' },
  { value: 'Pacific/Chuuk', label: 'Chuuk (UTC+10)', region: 'Pacific' },
  { value: 'Pacific/Easter', label: 'Easter (UTC-6)', region: 'Pacific' },
  { value: 'Pacific/Efate', label: 'Efate (UTC+11)', region: 'Pacific' },
  { value: 'Pacific/Fakaofo', label: 'Fakaofo (UTC+13)', region: 'Pacific' },
  { value: 'Pacific/Fiji', label: 'Fiji (UTC+12)', region: 'Pacific' },
  { value: 'Pacific/Funafuti', label: 'Funafuti (UTC+12)', region: 'Pacific' },
  { value: 'Pacific/Galapagos', label: 'Galapagos (UTC-6)', region: 'Pacific' },
  { value: 'Pacific/Gambier', label: 'Gambier (UTC-9)', region: 'Pacific' },
  { value: 'Pacific/Guadalcanal', label: 'Guadalcanal (UTC+11)', region: 'Pacific' },
  { value: 'Pacific/Guam', label: 'Guam (UTC+10)', region: 'Pacific' },
  { value: 'Pacific/Honolulu', label: 'Honolulu (UTC-10)', region: 'Pacific' },
  { value: 'Pacific/Kanton', label: 'Kanton (UTC+13)', region: 'Pacific' },
  { value: 'Pacific/Kiritimati', label: 'Kiritimati (UTC+14)', region: 'Pacific' },
  { value: 'Pacific/Kosrae', label: 'Kosrae (UTC+11)', region: 'Pacific' },
  { value: 'Pacific/Kwajalein', label: 'Kwajalein (UTC+12)', region: 'Pacific' },
  { value: 'Pacific/Majuro', label: 'Majuro (UTC+12)', region: 'Pacific' },
  { value: 'Pacific/Marquesas', label: 'Marquesas (UTC-9:30)', region: 'Pacific' },
  { value: 'Pacific/Midway', label: 'Midway (UTC-11)', region: 'Pacific' },
  { value: 'Pacific/Nauru', label: 'Nauru (UTC+12)', region: 'Pacific' },
  { value: 'Pacific/Niue', label: 'Niue (UTC-11)', region: 'Pacific' },
  { value: 'Pacific/Norfolk', label: 'Norfolk (UTC+11)', region: 'Pacific' },
  { value: 'Pacific/Noumea', label: 'Noumea (UTC+11)', region: 'Pacific' },
  { value: 'Pacific/Pago_Pago', label: 'Pago Pago (UTC-11)', region: 'Pacific' },
  { value: 'Pacific/Palau', label: 'Palau (UTC+9)', region: 'Pacific' },
  { value: 'Pacific/Pitcairn', label: 'Pitcairn (UTC-8)', region: 'Pacific' },
  { value: 'Pacific/Pohnpei', label: 'Pohnpei (UTC+11)', region: 'Pacific' },
  { value: 'Pacific/Port_Moresby', label: 'Port Moresby (UTC+10)', region: 'Pacific' },
  { value: 'Pacific/Rarotonga', label: 'Rarotonga (UTC-10)', region: 'Pacific' },
  { value: 'Pacific/Saipan', label: 'Saipan (UTC+10)', region: 'Pacific' },
  { value: 'Pacific/Tahiti', label: 'Tahiti (UTC-10)', region: 'Pacific' },
  { value: 'Pacific/Tarawa', label: 'Tarawa (UTC+12)', region: 'Pacific' },
  { value: 'Pacific/Tongatapu', label: 'Tongatapu (UTC+13)', region: 'Pacific' },
  { value: 'Pacific/Wake', label: 'Wake (UTC+12)', region: 'Pacific' },
  { value: 'Pacific/Wallis', label: 'Wallis (UTC+12)', region: 'Pacific' },

  // UTC (1 timezone)
  { value: 'UTC', label: 'UTC (UTC+0)', region: 'UTC' },
] as const;

export const DELIVERY_HOURS = [
  { value: 5, label: '5:00 AM' },
  { value: 6, label: '6:00 AM' },
  { value: 7, label: '7:00 AM' },
  { value: 8, label: '8:00 AM' },
] as const;
